import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import BoletinesView from './BoletinesView';
import * as ROUTES from '../../../router/Routes';

const BoletinesModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.boletines}
      routes={[ROUTES.controlEstudios]}
    >
      <BoletinesView />
    </ContainerTemplate>
  );
};

export default BoletinesModule;
